import React, { useState, useEffect } from "react";
import APIService from "../../Services/API/APIService";
import {
  Table,
  Dimmer,
  Loader,
  Button,
  Dropdown,
  Menu,
  Form,
  Modal,
  Image
} from "semantic-ui-react";
import dayjs from "dayjs";
import numeral from "numeral";
import GuestHouseProduct from "./GuestHouseProduct";

const GuestHousePackages = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchPhrase, setSearchPhrase] = useState(null);
  const [packageModalState, togglePackageModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  useEffect(() => {
    let isSubscribed = true;
    fetchData(isSubscribed);
    return () => (isSubscribed = false);
  }, [packageModalState]);

  const fetchData = async (isSubscribed) => {
    try {
      setLoading(true);
      let result = await APIService.getData("/guest-house/getPackages");
      if(isSubscribed){
        setData(result);

      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const _searchChanged = (e) => {
    setSearchPhrase(e.target.value);
  };

  const openPackageModal = async (packages) => {
    try {
      setSelectedPackage(packages);
      togglePackageModal(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  const _search = async () => {
    setLoading(true);
    try {
      let result = [];
      if (searchPhrase) {
        result = await APIService.getData(`/order/search/${searchPhrase}`);
      } else {
        result = await APIService.getData("/order");
      }
      setLoading(false);
      setData(result);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const _deleteItem = async (item) => {
    try {
      setLoading(true);
      console.log(item);
      await APIService.postData(`/guest-house/deletePackage`, {
        id: item.id,
        key: item.key
      });

      fetchData();

      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const items = data?.map((item) => (
    <Table.Row key={item.id}>
      <Table.Cell>{dayjs(item.createdAt).format("DD-MMM-YYYY")}</Table.Cell>
      <Table.Cell>{item.name}</Table.Cell>
      <Table.Cell>₦{numeral(item.price).format("0,0")}</Table.Cell>
      <Table.Cell>

        <Image
          src={item.GuestHouseGalleries[0]?.resizeLocation}
          // style={{ height: 50 }}
          size='mini'
          bordered
        />
      </Table.Cell>

      <Table.Cell>
        <Dropdown  icon="ellipsis vertical" fluid  floating  pointing="bottom right">
          <Dropdown.Menu>
            <Dropdown.Item
              //disabled
              icon="edit"
              text="Edit Package"
              onClick={() => openPackageModal(item)}
            />
            <Dropdown.Item
              icon="trash"
              text="Delete"
              onClick={() => _deleteItem(item)}
            />
          </Dropdown.Menu>
        </Dropdown>
      </Table.Cell>
    </Table.Row>
  ));



  return (
    <div>
    {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}

      <Menu secondary stackable>
        <Menu.Item fitted>
          <Button onClick={() => openPackageModal()} style={{ backgroundColor: '#26f09e', color: '#000000' }}>
            Create Package
          </Button>
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <Form>
              <Form.Input
                placeholder="Name, Email or Phone"
                icon="search"
                onChange={_searchChanged}
                action={{
                  onClick: _search,
                }}
                disabled
              />
            </Form>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      {data && (
        <Table striped stackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Created On</Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Price</Table.HeaderCell>
              <Table.HeaderCell>Image</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{items}</Table.Body>
        </Table>
      )}


      <Modal
        size="small"
        // open={true}
        open={packageModalState}
        onClose={() => togglePackageModal(false)}
        closeIcon
      >
        <Modal.Header>{""}</Modal.Header>
        <Modal.Content>
          <GuestHouseProduct package={selectedPackage} togglePackageModal={togglePackageModal} />
        </Modal.Content>
      </Modal>



    </div>
  );
};

export default GuestHousePackages;
